import { mediaConstants } from './../_constants';
import { mediaServices } from './../_services';
import { alertActions } from './';

export const mediaActions = {
  listMediaByDomain
}

function listMediaByDomain(uuid){
  return dispatch => {
    dispatch(dAlert(mediaConstants.LIST_MEDIA_REQUEST, {uuid}));

    return mediaServices.listMediaByDomain(uuid)
      .then(data => {
          return dispatch(dAlert(mediaConstants.LIST_MEDIA_SUCCESS, data));
        },
        error => {
          dispatch(alertActions.failure(error));
          return dispatch(dAlert(mediaConstants.LIST_MEDIA_FAILURE, error));
        }
      )
  }
}

const dAlert = (constant, data) => {
  return { type: constant, data }
}